import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { CreateTinyAuthenticatedUrlCommandPayload } from '@/api/Notification/owners/createTinyAuthenticatedUrlCommand';

const ENDPOINT = `${APIConfiguration.notification}owners/${COMMON_QUERY_PARAMS.OWNER_ID}/sendBackOfficeLink`;

export const createAndSendTinyAuthenticatedUrlCommand = async (
  payload: CreateTinyAuthenticatedUrlCommandPayload,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await apiCall(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, payload.ownerId),
      {
        method: SUPPORTED_METHODS.POST,
        json: payload,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
